import { Model } from './model';
import { Incarico } from './incarico';
import { GruppoTipiDanno } from './gruppo-tipi-danno';

export class TipoDanno extends Model {
  static apiUrl: string = "tipi_danno";

  nome: string;
  incarichi: Incarico[];

  gruppo_tipi_danno: GruppoTipiDanno;


  deserialize(input: any): TipoDanno {
    let retV: TipoDanno = new TipoDanno();

    retV = super.deserialize(input) as TipoDanno;

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    }
    if (input?.gruppo_tipi_danno) {
      retV.gruppo_tipi_danno = new GruppoTipiDanno().deserialize(input.gruppo_tipi_danno);
    }

    return retV;
  }

  static getDefaultSortKey() {
    return 'nome';
  }
  static getDefaultSortDirection() {
    return 'asc';
  }
}
